export const getCreatedAtLabel = (createdAt: string) => {
  return `Added on ${new Date(createdAt).toLocaleDateString()}`;
};
